import { use } from 'react';
import { createLazyPromise } from '~/utils/promise';
import { fetchSanityInternetData } from '../internet.api';

const lazySanityInternetDataPromise = createLazyPromise(fetchSanityInternetData);

export const useLazySanityData = () => {
  // trigger promise executor on render
  lazySanityInternetDataPromise.trigger();
  return use(lazySanityInternetDataPromise.promise);
};
